<p-dialog [visible]="true" [breakpoints]="{'430px': '100%'}" [style]="{width: '40%'}" [baseZIndex]="10000"
  [modal]="true" [maximizable]="false" [draggable]="false" [resizable]="false">
  <dialog-header [title]="app.translations.GBL_btn_Export" [settings]="settings" [icon]="faFileExport"></dialog-header>  
  <div class="row" [ngClass]="settings.darkModeSetting ? 'bg-dark' : 'bg-white'">
    <div class="padding15" [ngClass]="mobileView ? 'col-12' : 'offset-1 col-9'">
      <span class="font14" [ngClass]="settings.darkModeSetting ? 'textWhite' : 'textBlack'">
        {{app.translations.GBL_lbl_ExportAllData}}
      </span>
      <mat-checkbox [checked]="false" (change)="toggleExportAll($event)" class="float-right" style="transform: translateY(-5px);"></mat-checkbox>      
    </div>
    <div class="padding15" [ngClass]="mobileView ? 'col-12' : 'offset-1 col-9'">
      <div class="flex animated fadeIn align-end" style="height: 35px;">
        <span class="font14"
          [ngClass]="settings.darkModeSetting ? 'textWhite' : 'textBlack'">{{app.translations.GBL_lbl_ExportFormat}}</span>
      </div>
      <div class="animated fadeIn">
        <select class="cursorPointer b-radius full-width form-select font14"
          [ngClass]="settings.darkModeSetting ? 'textWhite' : 'textBlack'" (change)="selectFormat($event)">
          <option selected>Excel (.xlsx)</option>
        </select>
      </div>
    </div>
    <div class="padding15" [ngClass]="mobileView ? 'col-12' : 'offset-1 col-9'">
      <div class="flex animated fadeIn align-end" style="height: 35px;">
        <span class="font14"
          [ngClass]="settings.darkModeSetting ? 'textWhite' : 'textBlack'">{{app.translations.GBL_lbl_ExportName}}</span>
      </div>
      <div class="animated fadeIn">
        <input class="form-control font14" [ngClass]="settings.darkModeSetting ? 'textWhite' : 'textBlack'"
          (change)="nameFile($event)" />
      </div>
    </div>
  </div>
  <div class="row sticky dialog-footer-container" [ngClass]="settings.darkModeSetting ? 'bg-dark' : 'bg-white'">
    <div class="col-12 unset-p">
      <div class="flex justify-right padding10 dialog-footer">
        <button class="btn font17" (click)="validateExport()">
          <fa-icon [icon]="faFileExport" class="textGreen"></fa-icon>
          <span [ngClass]="settings.darkModeSetting ? 'textWhite' : 'textBlack'">
            {{app.translations.GBL_btn_Export}}
          </span>
        </button>
      </div>
    </div>
  </div>
</p-dialog>